import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.FromPublishedFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  template: JST["backbone/templates/monitoring/filters/from_published/from_published_filter"]

  events:
    'click .apply': 'apply'


  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery

  apply: =>
    @searchQuery.setParentPostIsPublished(@getFilterValue())
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  render: ->
    @$el.html(@template(source: @source))
    @

  getFilterValue: =>
    filterValue = @$el.find('input[type="radio"]:checked').val()
    return @getBooleanOf(filterValue)

  getBooleanOf: (value) ->
    return value unless value?
    value == 'true'
